import React, { Component } from "react";


class ClassWorkoutVideo extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		isVideoLoaded: false,
		isVideoPlayed: false,
		durationWidth: 0,
		videoDurationMain: 0
    }
	
	this.videoInterval = null;
}
 
componentDidMount(){
	this.setEvents();
}

setEvents=()=>{
	var video = document.getElementById('video_work');
	var mainthis = this;
	video.oncanplay = function() {
		mainthis.setState({isVideoLoaded: true});
	}
	
	video.onended = function() {
		mainthis.setState({isVideoPlayed: false});
	}
	
	video.onloadedmetadata = function(){
		mainthis.setState({videoDurationMain: video.duration});
	}
}

playVideo=(videoSeconds)=>{
	var mainthis = this;
	var video = document.getElementById('video_work');
	video.play();
	this.setState({isVideoPlayed: true});
	
	this.videoInterval = setInterval(function(){
		if ( video.currentTime > -1  && !video.ended && video.readyState > 2 )
			{
				if ( videoSeconds ) 
					{ 
						video.currentTime = videoSeconds; 
						videoSeconds = null;
					}
				
				var percent = (video.currentTime / video.duration * 100);
				mainthis.setState({durationWidth: percent});
			}
		else
			{
				mainthis.pauseVideo();
				clearInterval(mainthis.videoInterval);
				mainthis.videoInterval = null;
				if ( video.ended )
					{
						mainthis.setState({durationWidth: 100});
					}
			}
	}, 500);
}

pauseVideo=()=>{
	var video = document.getElementById('video_work');
	video.pause();
	this.setState({isVideoPlayed: false});
	clearInterval(this.videoInterval);
	this.videoInterval = null;
}

setVideoDuration=(e)=>{
	var rect = e.target.getBoundingClientRect();
	var x = e.clientX - rect.left; //x position within the element.
	var divWidth = document.getElementById('outerLine').offsetWidth;
	var percentLine = (x / divWidth) * 100;
	var videoSeconds = (this.state.videoDurationMain * percentLine) / 100;
	
	if ( this.videoInterval )
		{
			clearInterval(this.videoInterval);
			this.videoInterval = null;
		}
	
	this.playVideo(videoSeconds);
}


  render() {
	 return (
		<div className="booked_pop_content">
			<div className="workout_video_container">
				<div className="close_pops"	onClick={() => this.props.updateStateFromChild({isOpenWorkoutVideo: false})}></div>
				<div className="video_name">{this.props.videoName}</div>
				<div className="workout_video_content">
					<video src={this.props.videoURL} id="video_work"></video>
					<div className="full_controls">
						{ this.state.isVideoLoaded && !this.state.isVideoPlayed &&
							<div className="play_control_class" onClick={() => this.playVideo()}></div>
						}
						{ this.state.isVideoLoaded && this.state.isVideoPlayed &&
							<div className="pause_control_class" onClick={this.pauseVideo}></div>
						}
						{ this.state.isVideoLoaded &&
							<div className="progress_video_content">
								<div className="relative_progress_app" id="outerLine" onMouseUp={this.setVideoDuration}>
									<div className="progress_inner_app" style={{width: this.state.durationWidth+'%'}}></div>
								</div>
							</div>
						}
					</div>
					{ !this.state.isVideoLoaded &&
						<div className="pending_video">Loading Video...</div>
					}
				</div>
				{ this.props.videoDescription && this.props.videoDescription !== '' &&
					<div className="video_description">{this.props.videoDescription}</div>
				}
			</div>
		</div>
    );
  }
}
export default ClassWorkoutVideo;
